export const arrow_down = {
	name: 'arrow-down',
	title: 'Arrow Down',
	content:
		'<path d="M 23.25,7.311L12.53,18.03c-0.292,0.293-0.767,0.293-1.059,0.001c0,0-0.001-0.001-0.001-0.001L0.75,7.311" stroke="currentColor" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>',
};
